import React from "react"
const InstructionContext = React.createContext({});

export default InstructionContext;